import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46697024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TUIChat-header" }
const _hoisted_2 = { class: "setting" }
const _hoisted_3 = { class: "TUIChat-main" }
const _hoisted_4 = { class: "TUIChat-safe-tips" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 【安全提示】请勿轻信汇款、中奖等涉及钱款的信息，勿轻易拨打陌生电话，谨防上当受骗。 ", -1))
const _hoisted_6 = ["id"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-bottom-double" }, null, -1))
const _hoisted_8 = { class: "to-bottom-tip-cont" }
const _hoisted_9 = {
  key: 0,
  class: "dialog dialog-conversation"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "name" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "name"
}
const _hoisted_14 = { class: "dialog dialog-conversation" }
const _hoisted_15 = { style: {"text-align":"center","color":"#7F7F7F","font-size":"14px","min-height":"50px","width":"100%"} }
const _hoisted_16 = {
  key: 0,
  style: {"display":"flex","align-items":"center","justify-content":"center","margin-bottom":"15px","padding-top":"10px"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { style: {"display":"flex","align-items":"center","justify-content":"center","margin-bottom":"15px"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  class: "func",
  id: "func"
}
const _hoisted_23 = { class: "func-main" }
const _hoisted_24 = { class: "mask-main" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_26 = {
  key: 1,
  class: "TUIChat"
}
const _hoisted_27 = { class: "TUIChat-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypingHeader = _resolveComponent("TypingHeader")!
  const _component_Manage = _resolveComponent("Manage")!
  const _component_Replies = _resolveComponent("Replies")!
  const _component_MessageTimestamp = _resolveComponent("MessageTimestamp")!
  const _component_MessageItem = _resolveComponent("MessageItem")!
  const _component_ReadReceiptDialog = _resolveComponent("ReadReceiptDialog")!
  const _component_imagePreviewer = _resolveComponent("imagePreviewer")!
  const _component_MessageInput = _resolveComponent("MessageInput")!
  const _component_MessageSystem = _resolveComponent("MessageSystem")!

  return (_ctx.conversationType === 'chat')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["TUIChat", [_ctx.env.isH5 ? 'TUIChat-H5' : '']])
      }, [
        _createElementVNode("header", _hoisted_1, [
          (_ctx.env.isH5)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "icon icon-back",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_TypingHeader, {
            needTyping: _ctx.needTyping,
            conversation: _ctx.conversation,
            messageList: _ctx.messageList,
            ref: "typingRef"
          }, null, 8, ["needTyping", "conversation", "messageList"]),
          _createElementVNode("aside", _hoisted_2, [
            (_ctx.conversation.groupProfile)
              ? (_openBlock(), _createBlock(_component_Manage, {
                  key: 0,
                  conversation: _ctx.conversation,
                  userInfo: _ctx.userInfo,
                  isH5: _ctx.env.isH5
                }, null, 8, ["conversation", "userInfo", "isH5"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Replies, {
              message: _ctx.currentMessage,
              conversation: _ctx.conversation,
              show: _ctx.repliesDialogStatus,
              isH5: _ctx.env.isH5,
              messageList: _ctx.messageList,
              onCloseDialog: _ctx.closeDialog,
              ref: "repliesDialog"
            }, null, 8, ["message", "conversation", "show", "isH5", "messageList", "onCloseDialog"])
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLink(_ctx.Link.complaint)))
            }, _toDisplayString(_ctx.$t('TUIChat.点此投诉')), 1)
          ]),
          _createElementVNode("ul", {
            class: "TUI-message-list",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogID = '')),
            ref: "messageEle",
            id: "messageEle"
          }, [
            (!_ctx.isCompleted)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "message-more",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getHistoryMessageList && _ctx.getHistoryMessageList(...args)))
                }, _toDisplayString(_ctx.$t('TUIChat.查看更多')), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                id: item?.ID,
                ref_for: true,
                ref: "messageAimID"
              }, [
                _createVNode(_component_MessageTimestamp, {
                  currTime: item?.time,
                  prevTime: index > 0 ? (_ctx.messages[index-1]?.time) : 0
                }, null, 8, ["currTime", "prevTime"]),
                _createVNode(_component_MessageItem, {
                  message: item,
                  env: _ctx.env,
                  types: _ctx.types,
                  displayGroupMessageReadReceipt: _ctx.needGroupReceipt,
                  displayEmojiReactions: _ctx.isNeedEmojiReact,
                  messageList: _ctx.messages,
                  onHandleEditor: _ctx.handleEditor,
                  onShowDialog: _ctx.showDialog,
                  onUploading: _ctx.handleUploadingImageOrVideo,
                  onJumpID: _ctx.jumpID,
                  onResendMessage: _ctx.resendMessage,
                  myuid: _ctx.myuid,
                  touid: _ctx.touid,
                  interviewList: _ctx.interviewList,
                  contactList: _ctx.contactList,
                  companyEntryInviteList: _ctx.companyEntryInviteList,
                  parentMethod: _ctx.parentMethod,
                  companyInfo: _ctx.companyInfo
                }, null, 8, ["message", "env", "types", "displayGroupMessageReadReceipt", "displayEmojiReactions", "messageList", "onHandleEditor", "onShowDialog", "onUploading", "onJumpID", "onResendMessage", "myuid", "touid", "interviewList", "contactList", "companyEntryInviteList", "parentMethod", "companyInfo"])
              ], 8, _hoisted_6))
            }), 128)),
            (_ctx.needToBottom)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "to-bottom-tip",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToTarget('bottom')))
                }, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.toBottomTipCont), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512),
          (_ctx.forwardStatus && _ctx.messageComponents.Forward)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(), _createBlock(_resolveDynamicComponent('Forward'), {
                  list: _ctx.conversationData.list,
                  message: _ctx.currentMessage,
                  show: _ctx.forwardStatus,
                  isH5: _ctx.env.isH5,
                  "onUpdate:show": _cache[5] || (_cache[5] = (e) => (_ctx.forwardStatus = e))
                }, {
                  left: _withCtx(({ data }) => [
                    _createElementVNode("img", {
                      class: "avatar",
                      src: _ctx.conversationData.handleAvatar(data)
                    }, null, 8, _hoisted_10),
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.conversationData.handleName(data)), 1)
                  ]),
                  right: _withCtx(({ data }) => [
                    _createElementVNode("img", {
                      class: "avatar",
                      src: _ctx.conversationData.handleAvatar(data)
                    }, null, 8, _hoisted_12),
                    (!_ctx.env.isH5)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_13, _toDisplayString(_ctx.conversationData.handleName(data)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 40, ["list", "message", "show", "isH5"]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_ReadReceiptDialog, {
              message: _ctx.currentMessage,
              conversation: _ctx.conversation,
              show: _ctx.receiptDialogStatus,
              isH5: _ctx.env.isH5,
              onCloseDialog: _ctx.closeDialog,
              ref: "readReceiptDialog"
            }, null, 8, ["message", "conversation", "show", "isH5", "onCloseDialog"])
          ]),
          (_ctx.showImagePreview)
            ? (_openBlock(), _createBlock(_component_imagePreviewer, {
                key: 1,
                currentImage: _ctx.currentImagePreview,
                imageList: _ctx.imageList,
                onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showImagePreview = false))
              }, null, 8, ["currentImage", "imageList"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.currentiInterview&&(_ctx.currentiInterview.status == 3 || _ctx.currentiInterview.status == 4 || _ctx.currentiInterview.status == 5))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", null, [
                    _createTextVNode("温馨提示："),
                    (_ctx.iscmp==2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "您"))
                      : _createCommentVNode("", true),
                    (_ctx.iscmp == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                      : _createCommentVNode("", true),
                    _createTextVNode(" 已接受" + _toDisplayString(_ctx.currentiInterview.start_time) + "的面试邀请，请准时参加", 1)
                  ]),
                  _createElementVNode("div", {
                    style: {"margin-left":"15px","color":"#006EFF","cursor":"pointer"},
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openVideo()))
                  }, "查看面试直播间使用教程")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.currentiInterview&&_ctx.currentiInterview.status == 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, "温馨提示：面试即将开始，请您提前进入准备"))
                : _createCommentVNode("", true),
              (_ctx.currentiInterview&&_ctx.currentiInterview.status == 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, "温馨提示：面试已开始，请您准时进入"))
                : _createCommentVNode("", true),
              (_ctx.currentiInterview&&(_ctx.currentiInterview.status == 4 || _ctx.currentiInterview.status == 5))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.live_tdds_info(_ctx.currentiInterview.live_id))),
                    style: {"width":"80px","height":"26px","margin-left":"15px","background":"rgba(0, 110, 255, 1)","display":"flex","align-items":"center","justify-content":"center","border-radius":"5px","color":"#ffffff"}
                  }, " 立即进入"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["TUIChat-footer", [_ctx.isMute && 'disabled', _ctx.env.isH5 && 'TUIChat-H5-footer']])
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("main", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pluginComponentList, (item, index) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
                  key: index,
                  isMute: _ctx.isMute,
                  isH5: _ctx.env.isH5,
                  conversation: _ctx.conversation,
                  parentID: "func",
                  onSend: _ctx.handleSend
                }, null, 40, ["isMute", "isH5", "conversation", "onSend"]))
              }), 128))
            ])
          ]),
          _createVNode(_component_MessageInput, {
            ref: "messageInput",
            conversation: _ctx.conversation,
            memberList: _ctx.allMemberList,
            env: _ctx.env,
            isGroup: _ctx.userInfo?.isGroup,
            replyOrReference: _ctx.reference,
            isMute: _ctx.isMute,
            muteText: _ctx.muteText,
            placeholder: _ctx.$t('TUIChat.请输入消息'),
            onSendMessage: _ctx.reportMessageSend,
            onResetReplyOrReference: _ctx.resetReplyOrReference,
            onOnTyping: _ctx.handleTyping
          }, null, 8, ["conversation", "memberList", "env", "isGroup", "replyOrReference", "isMute", "muteText", "placeholder", "onSendMessage", "onResetReplyOrReference", "onOnTyping"])
        ], 2),
        _withDirectives(_createElementVNode("div", {
          class: "mask",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showResend = false))
        }, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("header", null, _toDisplayString(_ctx.$t('TUIChat.确认重发该消息？')), 1),
            _createElementVNode("footer", null, [
              _createElementVNode("p", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showResend = false))
              }, _toDisplayString(_ctx.$t('TUIChat.取消')), 1),
              _hoisted_25,
              _createElementVNode("p", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, _toDisplayString(_ctx.$t('TUIChat.确定')), 1)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showResend]
        ])
      ], 2))
    : (_ctx.conversationType === 'system')
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("header", _hoisted_27, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.conversationName), 1)
          ]),
          _createVNode(_component_MessageSystem, {
            data: _ctx.messages,
            types: _ctx.types,
            onApplication: _ctx.handleApplication
          }, null, 8, ["data", "types", "onApplication"])
        ]))
      : (_ctx.slotDefault)
        ? _renderSlot(_ctx.$slots, "default", { key: 2 }, undefined, true)
        : _createCommentVNode("", true)
}